var Raven = require('raven-js');
var m = require('am');

m.run(['$window', 'config', function($window, config) {
    $window.Raven = Raven;
    Raven.config(config.sentry_dsn, {
      ignoreErrors: [
        'ReferenceError: Can\'t find variable: dataKeys',
        'parent is null',
        'Invalid argument',
        "'null' is not an object (evaluating 'parent.insertBefore')",
        'miscellaneous_bindings',
        "Cannot call method 'insertBefore' of null",
        "Cannot read property 'insertBefore' of null",
        "Unable to get property 'insertBefore' of undefined or null reference"
      ],
      ignoreUrls: [
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        /scribe.*command\.js/,
        /scribe.*command-patch\.js/
      ]
    }).install();
}]);

module.exports = Raven;



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/errors.js
 **/